export default __webpack_public_path__ + "static/Lato-Light-91308c0216b40aad16036f1394b98237.woff";